import React, { useEffect } from 'react';

import { useSearch } from '@hooks/useSearch';
import { url } from '@utils/pages';
import * as t from 'io-ts';
import { useHistory } from 'react-router-dom';
import * as h from 'tyrann-io';

const searchType = t.type({
  from: h.omittable(h.string()),
  d2dNo: h.string(),
});

export const DeliveryGuidance: React.FC = () => {
  const {
    search: { from, d2dNo },
  } = useSearch(searchType);

  const history = useHistory();

  useEffect(() => {
    history.push(
      `${url('/utilities/Bookings/CustomsInstruction')}?d2dNo=${d2dNo}&from=${from ?? ''}`,
    );
  });

  return <></>;
};
